var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_1024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16668 11.3215L9.16668 1.66301C9.16668 1.20479 9.53656 0.833328 10 0.833328C10.4602 0.833328 10.8333 1.20829 10.8333 1.66301L10.8333 11.3215L13.9941 8.16074C14.3195 7.8353 14.8472 7.8353 15.1726 8.16074C15.498 8.48618 15.498 9.01381 15.1726 9.33925L10.5893 13.9226C10.2638 14.248 9.73619 14.248 9.41075 13.9226L4.82742 9.33925C4.50198 9.01381 4.50198 8.48618 4.82742 8.16074C5.15286 7.8353 5.68049 7.8353 6.00593 8.16074L9.16668 11.3215ZM17.5 9.16666C17.5 8.70642 17.8731 8.33333 18.3333 8.33333C18.7936 8.33333 19.1667 8.70642 19.1667 9.16666L19.1667 17.0797C19.1667 18.2325 18.234 19.1667 17.0806 19.1667L2.91939 19.1667C1.767 19.1667 0.833344 18.2326 0.833344 17.0797L0.833344 9.16666C0.833344 8.70642 1.20644 8.33333 1.66668 8.33333C2.12691 8.33333 2.50001 8.70642 2.50001 9.16666L2.50001 17.0797C2.50001 17.3123 2.68763 17.5 2.91939 17.5L17.0806 17.5C17.313 17.5 17.5 17.3126 17.5 17.0797L17.5 9.16666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_1024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIconLight);
export default __webpack_public_path__ + "static/media/pdfIconLight.389ae0a729ccda0a626612753b31b2ec.svg";
export { ForwardRef as ReactComponent };